import { render, staticRenderFns } from "./quessionnaireImgRadio.vue?vue&type=template&id=229a9fa7&scoped=true&"
import script from "./quessionnaireImgRadio.vue?vue&type=script&lang=js&"
export * from "./quessionnaireImgRadio.vue?vue&type=script&lang=js&"
import style0 from "./quessionnaireImgRadio.vue?vue&type=style&index=0&id=229a9fa7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229a9fa7",
  null
  
)

export default component.exports